import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { cancel, requestRecaptcha,
    submitRequest, requestPhoneCodes } from '../../../../actions/analytics-register'
import { selectErrorMessage,
    selectRecaptcha,
    selectQuickRegister,
    selectStep,
    selectPhoneCodes } from '../../../../reducers/analytics-register'


const mapStateToProps = createStructuredSelector({
    errorMessage: selectErrorMessage,
    phoneCodes: selectPhoneCodes,
    recaptchaValue: selectRecaptcha,
    stepNumber: selectStep,
    submitRequest: selectQuickRegister
})

const mapDispatchToProps = dispatch => {
    return {
        onCancel: () => dispatch(cancel()),
        onRequestPhoneCodes: () => dispatch(requestPhoneCodes()),
        onRequestRecaptcha: () => dispatch(requestRecaptcha()),
        onSubmitRequest: values => dispatch(submitRequest(values))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
